// import Popup from './modules/popup';
import mainSlider from './modules/mainSlider';
import partnersSlider from './modules/partnersSlider';
import sliderArticles from './modules/sliderArticles';
import sidebarCatalog from './modules/sidebarCatalog';
import catalogNav from './modules/catalogNav';
import longTitle from './modules/longTitle';
import postSlider from './modules/postSlider';
import postTabs from './modules/postTabs';
import map from './modules/map';
import popup from './modules/popup';
import form from './modules/form';
import dropdown from './modules/dropdown';


// Popup();

// eslint-disable-next-line no-undef
GLightbox();
// eslint-disable-next-line no-undef
svg4everybody();

$('[name=телефон]').mask('+7(999) 999-9999');
mainSlider();
partnersSlider();
sliderArticles();
sidebarCatalog();
catalogNav();
longTitle();
postSlider();
postTabs();
map();
popup();
form();
dropdown();


